"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonCardCustom = void 0;
const React = require("react");
const filters_1 = require("../../../utils/filters/filters");
const constants_1 = require("../../../utils/constants");
const BronsonCardCustom = ({ currentData, mapperCardView, removeItems, currencyItems, dateItems, underline, cardCustomId, }) => {
    const row = (item) => {
        const cardData = item.filter((info) => removeItems.includes(info.id) === false);
        return mapperCardView.map((elem, index) => {
            const dataByType = cardData.filter((card) => elem.data.includes(card.id));
            const isLastItem = index === mapperCardView.length - constants_1.one;
            if (removeItems.includes(elem.title)) {
                return React.createElement(React.Fragment, { key: index });
            }
            return (React.createElement("div", { className: `o-layout__item u-p-xsmall ${elem.size ? elem.size : 'u-1/1'}  u-1/1@s`, key: `layout-${index}` },
                React.createElement("h4", { className: 'u-text-brand u-pl-small' }, elem.title),
                dataByType.map((dataType, ind) => {
                    let currentElement = dataType;
                    if (currencyItems.includes(dataType.id) &&
                        currentElement.value) {
                        currentElement = Object.assign(Object.assign({}, dataType), { value: filters_1.filters.currency(dataType.value) });
                    }
                    else if (dateItems.includes(dataType.id) &&
                        currentElement.value) {
                        currentElement = Object.assign(Object.assign({}, dataType), { value: filters_1.filters.date(dataType.value) });
                    }
                    return (React.createElement("div", { key: `key_${ind}`, className: `o-layout__item ${elem.sizeItem ? elem.sizeItem : 'u-1/3'} u-pl-small u-1/1@s` },
                        React.createElement("b", { className: 'u-text-brand' }, currentElement.label),
                        React.createElement("p", { className: 'u-text-base u-mr' }, currentElement.value)));
                }),
                !isLastItem && underline && (React.createElement("hr", { style: { backgroundColor: '#a8adb3' } }))));
        });
    };
    return (React.createElement("div", { className: 'o-layout__item u-p-none u-1/1 u-1/1@s', "data-component": `${cardCustomId}` },
        React.createElement("div", { className: 'o-layout__item u-p-none u-1/1 u-10/12@s' }, row(currentData))));
};
exports.BronsonCardCustom = BronsonCardCustom;
